import api from '@/sui/api/cloud'
import sc from '@/sui/sc/config.json'

let version = 4

const debug = process.env.VUE_APP_SPIADI_DEBUG === '1'
if (debug) {
  version = version + 1
}

const state = {
  cfg: {
    presentation: null,
    news: null,
    faq: null,
    options: null
  },

  loaded: false
}

const getters = {
  getActu: state => (yearKey, monthKey, date) => {
    const list = state.cfg.news.videos.years
    for (let i = 0; i !== list.length; ++i) {
      const year = list[i]
      if (year.key !== yearKey) {
        continue
      }

      for (let j = 0; j !== year.months.length; ++j) {
        const month = year.months[j]
        if (month.key !== monthKey) {
          continue
        }

        for (let k = 0; k !== month.links.length; ++k) {
          const link = month.links[k]
          if (link.date === date) {
            return link
          }
        }
      }
    }

    return null
  }
}

// actions
const actions = {
  getConfig ({ commit }) {
    const request = {
      f: `config_v${version}.json`
    }
    return api.get(request).then(
      r => {
        if (r.data.err == null) {
          commit('setConfig', r.data.v)
        } else {
          commit('setConfig', sc)
        }
        return r
      }
    ).catch(
      e => {
        commit('setConfig', sc)
      }
    )
  }
}

// mutations
const mutations = {
  setConfig (state, v) {
    for (let k in state.cfg) {
      state.cfg[k] = v[k]
    }
    state.loaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
